import React from 'react';
import { UserIcon } from 'lucide-react';
const ProjectsTable = () => {
  const projects = [{
    id: 1,
    name: 'TEXBAU 637463',
    company: 'Wayne Enterprises',
    author: 'Wayne Admin',
    phase: 'Geschlossen',
    date: '22.05.25, 13:48',
    tasks: 2,
    questions: 0
  }, {
    id: 2,
    name: 'TEXBAU 637463',
    company: 'Wayne Enterprises',
    author: 'Wayne Admin',
    phase: 'Closed',
    date: '22.05.25, 09:59',
    tasks: 1,
    questions: 0
  }, {
    id: 3,
    name: 'Test Projekt',
    company: 'Wayne Enterprises',
    author: 'Wayne Admin',
    phase: 'Vorbereitung',
    date: '17.01.25, 10:17',
    tasks: 1,
    questions: 0
  }, {
    id: 4,
    name: 'Pappkarton Beispielprojekt',
    company: 'Wayne Enterprises',
    author: 'Wayne Admin',
    phase: 'Closed',
    date: '04.11.24, 15:19',
    tasks: 1,
    questions: 0
  }, {
    id: 5,
    name: 'Beispielprojekt Allgemein',
    company: 'Wayne Enterprises',
    author: 'Wayne Admin',
    phase: 'Präparation',
    date: '04.11.24, 11:41',
    tasks: 2,
    questions: 0
  }];
  return <div className="bg-white rounded shadow mt-4" data-id="element-57">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-58">
        <h2 className="text-base font-semibold text-gray-800" data-id="element-59">
          Laufende Beschaffungsprojekte
        </h2>
        <div className="relative" data-id="element-60">
          <input type="text" placeholder="Suche" className="pl-8 pr-4 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 text-sm" data-id="element-61" />
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2" data-id="element-62">
            <svg className="h-3 w-3 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-63">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" data-id="element-64" />
            </svg>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto" data-id="element-65">
        <table className="min-w-full" data-id="element-66">
          <thead className="bg-gray-100" data-id="element-67">
            <tr data-id="element-68">
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-69">
                Name
                <button className="ml-1 text-xs" data-id="element-70">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-71">
                Autor
                <button className="ml-1 text-xs" data-id="element-72">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-73">
                Aktive Phase
              </th>
              <th scope="col" className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-74">
                Erstellungsdatum
                <button className="ml-1 text-xs" data-id="element-75">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-76">
                Lieferanten
              </th>
              <th scope="col" className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-77">
                Aufgaben
                <button className="ml-1 text-xs" data-id="element-78">↓</button>
              </th>
              <th scope="col" className="px-4 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-79">
                Offene Fragen
                <button className="ml-1 text-xs" data-id="element-80">↓</button>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white" data-id="element-81">
            {projects.map(project => <tr key={project.id} className="border-t border-gray-100" data-id="element-82">
                <td className="px-4 py-3" data-id="element-83">
                  <div className="text-sm font-medium text-blue-600" data-id="element-84">
                    {project.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-85">{project.company}</div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-86">
                  <div className="flex items-center" data-id="element-87">
                    <div className="h-7 w-7 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-88">
                      <UserIcon className="h-3 w-3 text-blue-500" data-id="element-89" />
                    </div>
                    <div className="ml-2 text-sm text-gray-900" data-id="element-90">
                      {project.author}
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-91">
                  {project.phase}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500" data-id="element-92">
                  {project.date}
                </td>
                <td className="px-4 py-3 whitespace-nowrap" data-id="element-93">
                  <div className="flex justify-center" data-id="element-94">
                    <div className="h-7 w-7 rounded-full bg-gray-800 flex items-center justify-center text-white text-xs" data-id="element-95">
                      S
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-96">
                  {project.tasks}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-center text-sm text-gray-500" data-id="element-97">
                  {project.questions}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};
export default ProjectsTable;